import { CommunicationRateSection } from "pages/home/components/CommunicationSection/CommunicationRateSection";
import { RecentCommunicationsSection } from "pages/home/components/CommunicationSection/RecentCommunicationsSection";
import { Row1 } from "pages/home/components/Layout";

/**
 * 문의 섹션
 */
export const CommunicationSection = ({
  filteredSuggests,
  filteredInquiries,
  suggestPer,
  suggestPer1,
  inquiriesPer,
  inquiriesPer1,
  slicedData,
}) => {
  return (
    <Row1>
      {/* 좌측 : 건의/문의 처리율 */}
      <CommunicationRateSection
        filteredSuggests={filteredSuggests}
        filteredInquiries={filteredInquiries}
        suggestPer1={suggestPer1}
        suggestPer={suggestPer}
        inquiriesPer1={inquiriesPer1}
        inquiriesPer={inquiriesPer}
      />

      {/* 우측 : 최근 올라온 건의/문의*/}
      <RecentCommunicationsSection slicedData={slicedData} />
    </Row1>
  );
};
